/* Fetch the existing itinerary controller near its content, not during hero rendering. */
(() => {
  'use strict';
  if (window.MRWorkshopItineraryLoader) return;
  window.MRWorkshopItineraryLoader = true;
  const scriptURL = document.currentScript?.dataset.controller;
  if (!scriptURL || !window.customElements) return;
  let pending = null;
  const load = () => {
    if (customElements.get('mr-itinerary-gallery')) return Promise.resolve();
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptURL;
      script.async = true;
      script.onload = () => {
        if (customElements.get('mr-itinerary-gallery')) resolve();
        else { pending = null; script.remove(); reject(new Error('Itinerary controller unavailable')); }
      };
      script.onerror = () => { pending = null; script.remove(); reject(new Error('Itinerary controller could not load')); };
      document.head.appendChild(script);
    });
    return pending;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) load().then(() => observer.disconnect()).catch(() => {});
    });
  }, { rootMargin: '450px 0px' }) : null;
  const observe = scope => {
    const galleries = scope.matches?.('mr-itinerary-gallery') ? [scope] : Array.from(scope.querySelectorAll('mr-itinerary-gallery'));
    galleries.forEach(gallery => {
      gallery.setAttribute('data-workshop-controls-ready', '');
      // Match the existing controller's uncropped photo sizing before its download.
      // This uses attributes only, not layout reads, so registration cannot shift a day.
      gallery.querySelectorAll('[data-itinerary-slide] img').forEach(image => {
        const ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
        if (!(ratio > 0) || !Number.isFinite(ratio)) return;
        const width = 80 * Math.sqrt(ratio);
        const height = 80 / Math.sqrt(ratio);
        const scale = Math.min(1, 100 / width, 100 / height);
        image.style.width = `${width * scale}%`;
        image.style.height = `${height * scale}%`;
      });
      if (observer) observer.observe(gallery);
      else load().catch(() => {});
    });
  };
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('mr-itinerary-gallery').forEach(gallery => observer?.unobserve(gallery)));
  ['pointerover', 'focusin', 'touchstart'].forEach(type => document.addEventListener(type, event => {
    if (event.target.closest?.('mr-itinerary-gallery')) load().catch(() => {});
  }, { passive: true }));
  document.addEventListener('click', event => {
    if (customElements.get('mr-itinerary-gallery')) return;
    const target = event.target.closest?.('[data-itinerary-step], [data-itinerary-expand], .ctc-day__photo-image');
    const gallery = target?.closest('mr-itinerary-gallery');
    if (!gallery) return;
    event.preventDefault(); event.stopImmediatePropagation();
    load().then(() => { if (target.isConnected) target.click(); }).catch(() => {
      // A failed enhancement must not trap the visitor or hide the photographs.
      if (target.matches('[data-itinerary-expand], .ctc-day__photo-image')) {
        const image = gallery.querySelector('[data-itinerary-slide].is-active img');
        const url = image?.dataset.fullSrc || image?.currentSrc || image?.src;
        if (url) window.location.assign(url);
      } else {
        const counter = gallery.querySelector('.ctc-day__photo-count');
        if (counter) counter.setAttribute('aria-label', 'Photo controls could not load. Please try again.');
      }
    });
  }, true);
})();
